import type { CommissionOption, CommissionsConditionTypes, RuleCondition } from '~/consts/agentHub';

export type CommissionGroupOperator = 'AND' | 'OR';
export type CommissionConditionOperator = 'eq' | 'gt' | 'lt' | 'gte' | 'lte' | 'neq';

export type CommissionGroupConditionPayload = {
  operator: CommissionConditionOperator;
  value: string;
  type: string;
};

export type CommissionGroupPayload = {
  operator: CommissionGroupOperator;
  conditions: Array<CommissionGroupConditionPayload>;
};

export type CommissionConditionForm = {
  id: string;
  type: CommissionsConditionTypes;
  operator: CommissionConditionOperator;
  value: CommissionOption;
};

export type CommissionGroupForm = {
  id: string;
  operator: CommissionGroupOperator;
  conditions: Array<CommissionConditionForm>;
};

export type CommissionGroupsForm = Record<CommissionGroupOperator, CommissionGroupForm>;

export type AddConditionHandler = (
  groupId: CommissionGroupOperator,
  conditionId: string,
  newCondition: RuleCondition,
) => void;
export type ChangeConditionHandler = (
  groupId: CommissionGroupOperator,
  conditionId: string,
  type: CommissionsConditionTypes,
) => void;
export type ChangeConditionOperatorHandler = (
  groupId: CommissionGroupOperator,
  conditionId: string,
  operator: CommissionConditionOperator,
) => void;
export type ConditionIdHandler = (groupId: CommissionGroupOperator, conditionId: string) => void;
export type GroupIdHandler = (groupId: CommissionGroupOperator) => void;

export const CONDITION_OPERATORS: Array<CommissionConditionOperator> = ['eq', 'neq', 'gt', 'gte', 'lt', 'lte'];
export const GROUP_OPERATORS: Array<CommissionGroupOperator> = ['AND', 'OR'];
export const TEXT_TRANSFORM_NONE = { textTransform: 'none' };
export const CONDITION_OPERATOR_SYMBOL: Record<CommissionConditionOperator, string> = {
  eq: '=',
  neq: '!=',
  gt: '>',
  gte: '>=',
  lt: '<',
  lte: '<=',
};
export const OPERATOR_TEXT_MAP: Record<CommissionGroupOperator, string> = {
  AND: 'All conditions must be satisfied',
  OR: 'At least one condition must be satisfied',
};

export const createFormId = () => `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export function getCommissionGroupInitialState(): CommissionGroupsForm {
  return {
    AND: {
      id: createFormId(),
      operator: 'AND',
      conditions: [],
    },
    OR: {
      id: createFormId(),
      operator: 'OR',
      conditions: [],
    },
  };
}
